/**
 * Algolia Event System
 * Provides custom events for tracking Algolia interactions
 */

const AlgoliaEvents = {
  dispatch: function(eventName, detail) {
    const event = new CustomEvent(eventName, {
      detail: detail,
      bubbles: true,
      cancelable: true
    });
    document.dispatchEvent(event);
  },

  on: function(eventName, handler) {
    document.addEventListener(eventName, handler);
  },

  off: function(eventName, handler) {
    document.removeEventListener(eventName, handler);
  },

  types: {
    QUERY_RECEIVED: 'algolia:queryReceived',
    PRODUCT_CLICK: 'algolia:productClick',
    ADD_TO_CART: 'algolia:addToCart',
    CONVERSION: 'algolia:conversion'
  }
};

window.AlgoliaEvents = AlgoliaEvents;
